import React, { Dispatch, SetStateAction } from "react";
import { Tooltip, PlacesType } from "react-tooltip";

interface ReactTooltipProps {
  anchorSelect: string;
  children: React.ReactNode;
  place?: PlacesType;
  isOpen?: boolean;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
  openOnClick?: boolean;
  clickable?: boolean;
  globalCloseEvents?: {
    clickOutsideAnchor: boolean;
    escape: boolean;
  };
  noAnimation?: boolean;
  maxWidth?: string;
}
/**
 * Place it under the element of the component you want the tooltip to hover.
 * importing a css does not work, styles need to be directly placed
 * @param anchorSelect: the id of the element the tooltip it will show
 * @param children: chilren
 * @param place: defaults "top", but it is responsive enough
 * @param isOpen: boolean to control the tooltip
 * @param setIsOpen: function to control the tooltip
 * @returns <ReactTooltip>
 */
const ReactTooltip: React.FC<ReactTooltipProps> = ({
  anchorSelect,
  children,
  place = "top",
  isOpen,
  setIsOpen,
  openOnClick = false,
  clickable = false,
  globalCloseEvents = { clickOutsideAnchor: true, escape: true },
  noAnimation = false,
  maxWidth = "280px",
}) => {
  const baseStyle = {
    backgroundColor: 'var(--color-background-surface-02)',
    color: 'var(--color-text-body-muted)',
    padding: "8px 12px",
    boxShadow: '0 4px 20px 0 var(--ui-tooltip-shadow)',
    zIndex: 9999,
    maxWidth,
    wordWrap: "break-word" as const
  }
  const animationStyle = noAnimation ? { transition: 'none', animation: 'none' } : {}

  return (
    <Tooltip
      className="react-tooltip"
      anchorSelect={anchorSelect}
      place={place}
      opacity={1}
      style={{ ...baseStyle, ...animationStyle }}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      openOnClick={openOnClick}
      clickable={clickable}
      globalCloseEvents={globalCloseEvents}
    >
      {children}
    </Tooltip>
  )
}

export default ReactTooltip
